/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {TextField} from "../../../tools/model/form/TextField";
import {GrantType} from "../../../tools/model/auth/GrantType";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {CheckboxField} from "../../../tools/model/form/CheckboxField";
import {SelectField} from "../../../tools/model/form/SelectField";
import {Selectable} from "../../../tools/model/form/Selectable";
import {ClientDTO} from "../../dto/client/ClientDTO";

export default class ClientForm extends AbstractForm<ClientDTO> {

    constructor(grantTypes: Array<GrantType>, dto?: ClientDTO) {
        super();

        let selectableValues: Array<Selectable<GrantType>> = grantTypes.map(grantType => {
            return {value: grantType, name: grantType.toString(), disabled: false};
        })

        this.fields.set(ClientDTO.NAME, new TextField(
            ClientDTO.NAME,
            (t: Translation) => t.clientListColName,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(ClientDTO.REDIRECT_URI, new TextField(
            ClientDTO.REDIRECT_URI,
            (t: Translation) => t.redirectUri,
            value => value.toString().length > 0,
            Type.TEXT,
            true,
            "",
            ""
        ));

        this.fields.set(ClientDTO.SCOPE, new TextField(
            ClientDTO.SCOPE,
            (t: Translation) => t.clientListColScope,
            value => value.toString().length > 0,
            Type.TEXT,
            false,
            "",
            ""
        ));
        this.fields.set(ClientDTO.LOGO_URL, new TextField(
            ClientDTO.LOGO_URL,
            (t: Translation) => "Logo URL",
            value => value.toString().length > 0,
            Type.TEXT,
            false,
            "",
            ""
        ));

        this.fields.set(ClientDTO.OPEN_REGISTRATION, new CheckboxField(
            ClientDTO.OPEN_REGISTRATION,
            (t: Translation) => t.openRegistration,
            () => true,
            Type.CHECKBOX,
            false,
            false,
            false
        ));

        this.fields.set(ClientDTO.GRANT_TYPES, new SelectField(
            selectableValues,
            ClientDTO.GRANT_TYPES,
            (t: Translation) => t.grantTypes,
            () => true,
            Type.SELECT,
            true,
            true,
            [],
            []
        ));

        if (dto) super.load(dto);
    }
}
